import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Button } from "@gemini/ui";
import { FloorPlanIcon, CameraIcon, ThreeDimensionalFilledIcon, PlayCircleIcon, } from "@gemini/icons";
import { useI18n } from "@/shared/hooks";
import { TAB_ITEMS } from "@/components/UI/Tabs/contants";
import { useGalleryContext } from "@/gallery/contexts";
import { useRichMedias } from "@/components/Sections/RichMedias";
import { usePreviewGallery } from "@/gallery/hooks";
export const DesktopPreviewCTA = ({ openOnSlideIndex, testId, }) => {
    const { t } = useI18n();
    const { displayImgCTA, displayFloorplanCTA, itemsCount } = usePreviewGallery();
    const { updateTab, openSliderModal } = useGalleryContext();
    const { medias } = useRichMedias();
    const desktopPreviewTestId = `${testId}-desktop-preview`;
    // const displayVideoCTA = medias.some((m) => m.urlType === "MOVIE") => FIXME We will temporary hide this CTA, waiting for a new design
    const displayVideoCTA = false;
    const displayVirtualCTA = medias.some((m) => m.urlType === "VIRTUAL_TOUR");
    const handleFloorplansPress = () => {
        updateTab(TAB_ITEMS.FLOORPLANS);
        openSliderModal();
    };
    const handleImagesPress = () => {
        updateTab(TAB_ITEMS.IMAGES);
        openOnSlideIndex(0);
    };
    const handleScrollToRichMedia = () => {
        // eslint-disable-next-line no-restricted-globals
        const richMediaSection = document.getElementById("richMedia");
        richMediaSection === null || richMediaSection === void 0 ? void 0 : richMediaSection.scrollIntoView({ behavior: "smooth" });
    };
    return (_jsxs(Box, { position: "absolute", left: "spacing.16", bottom: "spacing.16", display: "flex", gap: "spacing.12", children: [displayImgCTA && (_jsx(Button, { onPress: handleImagesPress, variant: "secondary-floating", icon: CameraIcon, size: "40", testId: `${desktopPreviewTestId}-cta-images`, children: t("gallery.images.cta", { count: itemsCount }) })), displayFloorplanCTA && (_jsx(Button, { onPress: handleFloorplansPress, variant: "secondary-floating", icon: FloorPlanIcon, size: "40", testId: `${desktopPreviewTestId}-cta-floorplans`, children: t("gallery.floorplans.cta") })), displayVirtualCTA && (_jsx(Button, { onPress: handleScrollToRichMedia, variant: "secondary-floating", icon: ThreeDimensionalFilledIcon, size: "40", testId: `${desktopPreviewTestId}-cta-virtual`, children: t("richMedia.preview.3dTour.tag") })), displayVideoCTA && (_jsx(Button, { onPress: handleScrollToRichMedia, variant: "secondary-floating", icon: PlayCircleIcon, size: "40", testId: `${desktopPreviewTestId}-cta-video`, children: t("richMedia.preview.video.tag") }))] }));
};
